// Module
var code = `<div class="js-export-screen-maim">
    <terceraComboBox name="exportToItems" tooltip="{{.cbFormatTooltip}}" items={{.cbItems}} on-ValueChange="ExportTypeChanged"/>
    <terceraTextBox text="{{.saveFileName}}"  tooltip="{{.saveFileName}}" name="fileNameTB" />
    
    <div class="js-checkboxlist-panel"> 
        <div class="js-scrollable-container">
            <terceraPanel name="checkBoxList"/>
        </div>
    </div>
    
    <div class="check-box-container">
        <reactFormLabel label="{{~/checkAllText}}">
            <reactCheckbox 
                checked="{{.Checked}}" 
                on-onChange="@this.onCheckAllStateChange(\$1)" />
        </reactFormLabel>
    </div>

    <div class="buttons-bar">
        <terceraButton terceraButtonStyle="{{.btnOKStyle}}" text="{{.okText}}" on-btnClick="okClick"/>
        <terceraButton terceraButtonStyle="{{.btnCancelStyle}}" text="{{.cancelText}}" on-btnClick="cancelClick"/>
    </div>
</div>`;
// Exports
export default code;